import { useCallback, useEffect, useState } from 'react';
import { organizationsApi, OrganizationResponse } from '../../api/organizations';
import { GQLArgs } from '../../types';

const shapeOrg = (o: OrganizationResponse) => ({
  logoUrl: o.logo_url,
  active: o.active,
  refId: o.ref_id,
  name: o.name,
  slug: o.slug,
  settings: o.settings,
  parent: null,
});

export const useQueryClinics = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<{ organizations: { nodes: any[] } } | undefined>();

  useEffect(() => {
    setLoading(true);
    organizationsApi
      .list()
      .then((res) => {
        setData({
          organizations: {
            nodes: res.data.filter((o) => !o.ref_id || o.ref_id.length <= 4).map(shapeOrg),
          },
        });
      })
      .catch(() => setData(undefined))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
};

export const useLazyQueryClinic = (args?: GQLArgs<any> & { fetchPolicy?: string }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<{ organizations: { nodes: any[] } } | undefined>();

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await organizationsApi.list();
      const shaped = {
        organizations: {
          nodes: res.data.filter((o) => !o.ref_id || o.ref_id.length <= 4).map(shapeOrg),
        },
      };
      setData(shaped);
      args?.onCompleted?.(shaped);
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return [() => {}, { data: shaped, loading: false }] as const;
    } catch (err: any) {
      args?.onError?.(err);
    } finally {
      setLoading(false);
    }
  }, [args]);

  return { fetch, data, loading, called: !!data };
};
